/**
 * The order gaps are shown in, wherever they are shown (#2497).
 *
 * Extracted from the wizard summary so the settings card and the summary
 * cannot disagree about what comes first. Three places now report the same
 * gaps; a second copy of this list would eventually rank them differently.
 */

import type { ReadinessIssue } from './workshopReadiness';

/**
 * The order a workshop actually gets working in, which is neither the wizard's
 * step order nor the settings tab order. Each key is the thing that, when
 * missing, stops the next kind of work: you cannot receipt without identity,
 * invoice without bank details, price without a rate, book without services,
 * schedule without lifts, or assign without mechanics.
 */
const WORKFLOW_ORDER = [
  'businessId',
  'address',
  'contact',
  'bankIban',
  'laborRate',
  'services',
  'lifts',
  'mechanics',
] as const;

export function byWorkflowOrder(a: ReadinessIssue, b: ReadinessIssue): number {
  const rank = (key: string) => {
    const i = WORKFLOW_ORDER.indexOf(key as (typeof WORKFLOW_ORDER)[number]);
    // An unknown key is new; put it last rather than silently first.
    return i === -1 ? WORKFLOW_ORDER.length : i;
  };
  return rank(a.key) - rank(b.key);
}
